export const ALERT_STATUS = 'ALERT_STATUS'
export const LOADER_STATUS = 'LOADER_STATUS'
export const LANGUAGE = 'LANGUAGE'
export const VIEW_STATE_MANAGER = 'VIEW_STATE_MANAGER'
export const DISPLAY_DELETE_MODAL = 'DISPLAY_DELETE_MODAL'
export const SET_ORGANIZATION_CURRENCY = 'SET_ORGANIZATION_CURRENCY'
export const SET_ORGANIZATION_THEME = 'SET_ORGANIZATION_THEME'
export const ENABLE_ANONYMOUS_TRACKING = 'ENABLE_ANONYMOUS_TRACKING'
